export const createGetCalendarRequest = (page) => {
    return {
        url: "/calendar?page=" + page,
        method: "GET"
    };
}

export const createGetCalendarRequestV2 = (pageOffset, view_type) =>{
    return {
        url: "/calendar/v2",
        method: "GET",
        params: {
            offset: pageOffset,
            view_type
        }
    }
}

export const createGetNextFreeTimeSlotRequest = () => {
    return {
        url: "/calendar/next_free_time_slot",
        method: "GET",
    }
}